import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class HotkeyTemplateDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          fields={[
            'id',
            'name',
            'reference_id',
          ]}
          searchFn={searchFn}
          dropdownType='hotkey_template'
          type='hotkey_template'
          textFn={(doc) => doc.reference_id ?  doc.reference_id : null}
          component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
          onPostChange={onPostChange}
          preload={preload}
          valueField='id'
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(HotkeyTemplateDropdown);
